export const EMAIL_PREFERENCES_SUBMITTED_MESSAGE = 'Email Preferences successfully saved.';
